import Footer from "../../Footer/Footer";
import SigninSignupBackground from "../../SigninSignupBackground/SigninSignupBackground";
import RecoverPasswordForm from "./RecoverPasswordForm";

function Signin() {
    return (
      <div className="forgot-password">
        <SigninSignupBackground />
        <div className="forgot-password-form">
          <RecoverPasswordForm/>
          <Footer/>
        </div>
      </div>
    );
};

export default Signin;
